webpackJsonp([5],{

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(185);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactFa = __webpack_require__(546);

var _reactFa2 = _interopRequireDefault(_reactFa);

var _reactStatic = __webpack_require__(52);

var _reactLazyImages = __webpack_require__(527);

var _contactStyle = __webpack_require__(941);

var _contactStyle2 = _interopRequireDefault(_contactStyle);

var _reactLocalizeRedux = __webpack_require__(60);

var _global = __webpack_require__(68);

var _global2 = _interopRequireDefault(_global);

var _countryCode = __webpack_require__(783);

var _countryCode2 = _interopRequireDefault(_countryCode);

var _jobList = __webpack_require__(784);

var _jobList2 = _interopRequireDefault(_jobList);

var _utils = __webpack_require__(531);

var _axios = __webpack_require__(88);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContactPage = function (_React$PureComponent) {
  _inherits(ContactPage, _React$PureComponent);

  function ContactPage(props) {
    _classCallCheck(this, ContactPage);

    var _this = _possibleConstructorReturn(this, (ContactPage.__proto__ || Object.getPrototypeOf(ContactPage)).call(this, props));

    _this.onSubmit = function (e) {

      e.preventDefault();
      _this.setState({ busy: true });

      _axios2.default.post(_utils.baseURL + "contact", _this.state.form).then(function (response) {
        _this.setState({ success: true, message: response.data.message || response.message });
        setTimeout(function () {
          return _this.setState({ busy: false });
        }, 3000);
      }).catch(function (response) {
        _this.setState({ success: false, message: response.error });
        setTimeout(function () {
          return _this.setState({ busy: false });
        }, 3000);
      });
    };

    _this.setText = function (e) {
      var value = e.target.value;

      var inputName = e.target.getAttribute("data-name");
      _this.setState(function (prev) {
        return _extends({}, prev, { form: _extends({}, prev.form, _defineProperty({}, inputName, value)) });
      });
    };

    _this.resizeEventListener = function () {
      if (typeof window !== "undefined") {
        _this.setState({
          innerWidth: window.innerWidth
        });
      }
    };

    var activeLanguage = props.activeLanguage;

    var selector = (activeLanguage && activeLanguage.code) === "fr" ? 1 : 0;
    _this.state = {
      selector: selector,
      form: {
        countryCode: _countryCode.json[0].dial_code,
        "you-are": _global2.default.formPlaceholders.roles.one[selector]
      },
      innerWidth: typeof window !== "undefined" && window.innerWidth
    };
    return _this;
  }

  _createClass(ContactPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof window !== "undefined") {
        window.addEventListener("resize", this.resizeEventListener);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          options = _state.options,
          busy = _state.busy,
          success = _state.success,
          message = _state.message,
          selector = _state.selector;
      var activeLanguage = this.props.activeLanguage;
      var _state$innerWidth = this.state.innerWidth,
          innerWidth = _state$innerWidth === undefined ? typeof window !== "undefined" && window.innerWidth : _state$innerWidth;


      return _react2.default.createElement(
        _contactStyle2.default,
        null,
        _react2.default.createElement(
          'div',
          { className: 'xs-12', id: 'contact-page' },
          _react2.default.createElement(
            'section',
            { className: 'xs-12 header' },
            _react2.default.createElement(
              'div',
              { className: 'xs-12 md-11', style: { margin: "auto" } },
              _react2.default.createElement(
                'h3',
                null,
                _react2.default.createElement(_reactLocalizeRedux.Translate, { id: 'contact.heading' }),
                ' '
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactLocalizeRedux.Translate, { id: 'contact.sub-heading' }),
                ' '
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { className: 'xs-12 content' },
            _react2.default.createElement(
              'div',
              { className: 'xs-12 md-4 flex-wrap' },
              _react2.default.createElement(
                'p',
                { className: 'text-content' },
                _react2.default.createElement(_reactLocalizeRedux.Translate, { id: 'contact.content.left' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'xs-12 md-7 md-off-1' },
              _react2.default.createElement(
                'section',
                { className: 'xs-12 form-content' },
                _react2.default.createElement(
                  'form',
                  { className: 'xs-12', onSubmit: this.onSubmit, enctype: 'multipart/form-data',
                    method: 'POST', name: 'contact', 'data-netlify': 'true' },
                  _react2.default.createElement(
                    'div',
                    { className: 'xs-12 md-6' },
                    _react2.default.createElement(
                      'div',
                      { className: 'xs-12 form-control' },
                      _react2.default.createElement(
                        'label',
                        { htmlFor: 'nom' },
                        _global2.default.formPlaceholders.careers.firstname[selector]
                      ),
                      _react2.default.createElement('input', { placeholder: _global2.default.formPlaceholders.careers.firstname[selector],
                        'data-name': 'nom', type: 'text', onChange: this.setText, required: true })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'xs-12 form-control' },
                      _react2.default.createElement(
                        'label',
                        { htmlFor: 'prenom' },
                        _global2.default.formPlaceholders.careers.lasttname[selector]
                      ),
                      _react2.default.createElement('input', { placeholder: _global2.default.formPlaceholders.careers.lasttname[selector],
                        'data-name': 'prenom', type: 'text', onChange: this.setText, required: true })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'xs-12 md-6 form-control' },
                    _react2.default.createElement(
                      'label',
                      null,
                      'Email'
                    ),
                    _react2.default.createElement('input', { className: 'xs-12',
                      placeholder: _global2.default.formPlaceholders.contactUsPlaceholders.email[selector],
                      'data-name': 'email', onChange: this.setText })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'xs-12 md-6 form-control' },
                    _react2.default.createElement(
                      'label',
                      null,
                      _react2.default.createElement(_reactLocalizeRedux.Translate, { id: 'contact.role' })
                    ),
                    _react2.default.createElement(
                      'select',
                      { className: 'xs-12',
                        'data-name': 'you-are',
                        onChange: this.setText },
                      _react2.default.createElement(
                        'option',
                        null,
                        _global2.default.formPlaceholders.roles.one[selector]
                      ),
                      _react2.default.createElement(
                        'option',
                        null,
                        _global2.default.formPlaceholders.roles.two[selector]
                      ),
                      _react2.default.createElement(
                        'option',
                        null,
                        _global2.default.formPlaceholders.roles.three[selector]
                      ),
                      _react2.default.createElement(
                        'option',
                        null,
                        _global2.default.formPlaceholders.roles.four[selector]
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'xs-12 cjsx' },
                    _react2.default.createElement(
                      'div',
                      { className: 'xs-12 md-4 form-control' },
                      _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement(_reactLocalizeRedux.Translate, { id: 'contact.countrycode' })
                      ),
                      _react2.default.createElement(_countryCode2.default, { defaultValue: _countryCode.json[0].dial_code, onChange: this.setText })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'xs-12 md-8 form-control' },
                      _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement(_reactLocalizeRedux.Translate, { id: 'contact.phone' })
                      ),
                      _react2.default.createElement('input', { type: 'tel',
                        className: 'xs-12',
                        placeholder: _global2.default.formPlaceholders.contactUsPlaceholders.telephone[selector],
                        'data-name': 'telephone',
                        onChange: this.setText })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'xs-12 form-control' },
                    _react2.default.createElement(
                      'label',
                      null,
                      'Message'
                    ),
                    _react2.default.createElement('textarea', {
                      className: 'xs-12',
                      placeholder: _global2.default.formPlaceholders.contactUsPlaceholders.message[selector],
                      onChange: this.setText,
                      'data-name': 'message'
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'xs-12 form-control t-c' },
                    busy ? _react2.default.createElement(
                      _react.Fragment,
                      null,
                      _react2.default.createElement(
                        'button',
                        {
                          disabled: busy,
                          id: 'submit',
                          style: {
                            background: "white",
                            border: "2px solid lightgray",
                            color: "#444",
                            cursor: "spinner"
                          } },
                        _react2.default.createElement(_reactLocalizeRedux.Translate, { id: 'contact.pleaseWait' }),
                        _react2.default.createElement(_reactFa2.default, { icon: true, name: 'spinner', spin: true })
                      )
                    ) : _react2.default.createElement(
                      _react.Fragment,
                      null,
                      _react2.default.createElement(
                        'button',
                        { id: 'submit', disabled: busy },
                        _react2.default.createElement(_reactLocalizeRedux.Translate, { id: 'contact.button' })
                      )
                    ),
                    !busy && _react2.default.createElement(
                      'p',
                      { style: { padding: '9px 0 0', fontSize: '13px', color: success ? 'cadetblue' : 'red' } },
                      success ? _react2.default.createElement(_reactLocalizeRedux.Translate, { id: 'home.successMessage' }) : message
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ContactPage;
}(_react2.default.PureComponent);

exports.default = (0, _reactLocalizeRedux.withLocalize)(ContactPage);

/***/ }),

/***/ 522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(524);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LazyImage", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageState", function() { return a; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LazyImageFull", function() { return p; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intersection_observer__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_unionize__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_unionize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_unionize__);
var o=function(e,t){return(o=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)};var a,i=function(){return(i=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)};function c(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&(n[r[o]]=e[r[o]])}return n}!function(e){e.NotAsked="NotAsked",e.Loading="Loading",e.LoadSuccess="LoadSuccess",e.LoadError="LoadError"}(a||(a={}));var u=Object(__WEBPACK_IMPORTED_MODULE_2_unionize__["unionize"])({NotAsked:{},Buffering:{},Loading:{},LoadSuccess:{},LoadError:Object(__WEBPACK_IMPORTED_MODULE_2_unionize__["ofType"])()}),s=Object(__WEBPACK_IMPORTED_MODULE_2_unionize__["unionize"])({ViewChanged:Object(__WEBPACK_IMPORTED_MODULE_2_unionize__["ofType"])(),BufferingEnded:{},LoadSuccess:{},LoadError:Object(__WEBPACK_IMPORTED_MODULE_2_unionize__["ofType"])()}),d=function(e,t){return function(n){var r=g(l(e,t));r.promise.then(function(e){return n.update(s.LoadSuccess({}))}).catch(function(e){e.isCanceled||n.update(s.LoadError({msg:"Failed to load"}))}),n.promiseCache.loading=r}},f=function(e){e.promiseCache.buffering.cancel()},p=function(n){function r(e){var t=n.call(this,e)||this;return t.promiseCache={},t.initialState=u.NotAsked(),t.state=t.initialState,t.update=t.update.bind(t),t}return function(e,t){function n(){this.constructor=e}o(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}(r,n),r.reducer=function(e,t,n){return s.match(e,{ViewChanged:function(e){return!0===e.inView?n.src?u.match(t,{NotAsked:function(){return n.debounceDurationMs?{nextState:u.Buffering(),cmd:(e=n.debounceDurationMs,function(t){var n=g(m(e));n.promise.then(function(){return t.update(s.BufferingEnded())}).catch(function(e){}),t.promiseCache.buffering=n})}:{nextState:u.Loading(),cmd:d(n,n.experimentalDecode)};var e},default:function(){return{nextState:t}}}):{nextState:u.LoadSuccess()}:u.match(t,{Buffering:function(){return{nextState:u.NotAsked(),cmd:f}},default:function(){return{nextState:t}}})},BufferingEnded:function(){return{nextState:u.Loading(),cmd:d(n,n.experimentalDecode)}},LoadSuccess:function(){return{nextState:u.LoadSuccess()}},LoadError:function(e){return{nextState:u.LoadError(e)}}})},r.prototype.update=function(e){var t=this,n=r.reducer(e,this.state,this.props),o=n.nextState,a=n.cmd;this.props.debugActions&&("production"==="production"&&console.warn('You are running LazyImage with debugActions="true" in production. This might have performance implications.'),console.log({action:e,prevState:this.state,nextState:o})),this.setState(o,function(){return a&&a(t)})},r.prototype.componentWillUnmount=function(){this.promiseCache.loading&&this.promiseCache.loading.cancel(),this.promiseCache.buffering&&this.promiseCache.buffering.cancel(),this.promiseCache={}},r.prototype.render=function(){var n=this,r=this.props,o=r.children,d=r.loadEagerly,f=r.observerProps,p=c(r,["children","loadEagerly","observerProps","experimentalDecode","debounceDurationMs","debugActions"]);return d?o({imageState:u.LoadSuccess().tag,imageProps:p}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intersection_observer__["a" /* default */],i({rootMargin:"50px 0px",threshold:.01},f,{onChange:function(e){return n.update(s.ViewChanged({inView:e}))}}),function(e){return o({imageState:"Buffering"===n.state.tag?a.Loading:n.state.tag,imageProps:p,ref:e.ref})})},r.displayName="LazyImageFull",r}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),l=function(e,t){var n=e.src,r=e.srcSet,o=e.alt,a=e.sizes;return void 0===t&&(t=!1),new Promise(function(e,i){var c=new Image;if(r&&(c.srcset=r),o&&(c.alt=o),a&&(c.sizes=a),c.src=n,t&&"decode"in c)return c.decode().then(function(t){return e(t)}).catch(function(e){return i(e)});c.onload=e,c.onerror=i})},m=function(e){return new Promise(function(t){return setTimeout(t,e)})},g=function(e){var t=!1;return{promise:new Promise(function(n,r){e.then(function(e){return t?r({isCanceled:!0}):n(e)}),e.catch(function(e){return r(t?{isCanceled:!0}:e)})}),cancel:function(){t=!0}}},h=function(t){var n=t.actual,r=t.placeholder,o=t.loading,u=t.error,s=c(t,["actual","placeholder","loading","error"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(p,i({},s),function(e){var t=e.imageProps,i=e.ref;switch(e.imageState){case a.NotAsked:return!!r&&r({imageProps:t,ref:i});case a.Loading:return o?o():!!r&&r({imageProps:t,ref:i});case a.LoadSuccess:return n({imageProps:t});case a.LoadError:return u?u():n({imageProps:t})}})};h.displayName="LazyImage";
//# sourceMappingURL=react-lazy-images.es.js.map


/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InView */
/* unused harmony export useInView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);








var INSTANCE_MAP = new Map();
var OBSERVER_MAP = new Map();
/**
 * Monitor element, and trigger callback when element becomes visible
 * @param element {HTMLElement}
 * @param callback {Function} Called with inView
 * @param options {Object} InterSection observer options
 * @param options.threshold {Number} Number between 0 and 1, indicating how much of the element should be visible before triggering
 * @param options.root {HTMLElement} It should have a unique id or data-intersection-id in order for the Observer to reused.
 * @param options.rootMargin {String} The CSS margin to apply to the root element.
 * @param rootId {String} Unique identifier for the root element, to enable reusing the IntersectionObserver
 */

function observe(element, callback, options, rootId) {
  if (options === void 0) {
    options = {};
  }

  // Validate that the element is not being used in another <Observer />
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(!INSTANCE_MAP.has(element), "react-intersection-observer: Trying to observe %s, but it's already being observed by another instance.\nMake sure the `ref` is only used by a single <Observer /> instance.\n\n%s", element); // IntersectionObserver needs a threshold to trigger, so set it to 0 if it's not defined.
  // Modify the options object, since it's used in the onChange handler.

  if (!options.threshold) options.threshold = 0;
  var _options = options,
      root = _options.root,
      rootMargin = _options.rootMargin,
      threshold = _options.threshold;
  if (!element || !callback) return;
  var observerId = rootMargin ? threshold.toString() + "_" + rootMargin : threshold.toString();

  if (root) {
    observerId = rootId ? rootId + "_" + observerId : null;
  }

  var observerInstance = observerId ? OBSERVER_MAP.get(observerId) : null;

  if (!observerInstance) {
    observerInstance = new IntersectionObserver(onChange, options);
    if (observerId) OBSERVER_MAP.set(observerId, observerInstance);
  }

  var instance = {
    callback: callback,
    visible: false,
    options: options,
    observerId: observerId,
    observer: !observerId ? observerInstance : undefined
  };
  INSTANCE_MAP.set(element, instance);
  observerInstance.observe(element);
  return instance;
}
/**
 * Stop observing an element. If an element is removed from the DOM or otherwise destroyed,
 * make sure to call this method.
 * @param element {HTMLElement}
 */

function unobserve(element) {
  if (!element) return;
  var instance = INSTANCE_MAP.get(element);

  if (instance) {
    var observerId = instance.observerId,
        observer = instance.observer;
    var observerInstance = observerId ? OBSERVER_MAP.get(observerId) : observer;

    if (observerInstance) {
      observerInstance.unobserve(element);
    } // Check if we are still observing any elements with the same threshold.


    var itemsLeft = false;

    if (observerId) {
      INSTANCE_MAP.forEach(function (item, key) {
        if (item && item.observerId === observerId && key !== element) {
          itemsLeft = true;
        }
      });
    }

    if (observerInstance && !itemsLeft) {
      // No more elements to observe for threshold, disconnect observer
      observerInstance.disconnect();
      OBSERVER_MAP.delete(observerId);
    } // Remove reference to element


    INSTANCE_MAP.delete(element);
  }
}

function onChange(changes) {
  changes.forEach(function (intersection) {
    var isIntersecting = intersection.isIntersecting,
        intersectionRatio = intersection.intersectionRatio,
        target = intersection.target;
    var instance = INSTANCE_MAP.get(target); // Firefox can report a negative intersectionRatio when scrolling.

    if (instance && intersectionRatio >= 0) {
      var options = instance.options;
      var _inView = false;

      if (Array.isArray(options.threshold)) {
        // If threshold is an array, check if any of them intersects. This just triggers the onChange event multiple times.
        _inView = options.threshold.some(function (threshold) {
          return instance.visible ? intersectionRatio > threshold : intersectionRatio >= threshold;
        });
      } else if (options.threshold !== undefined) {
        // Trigger on 0 ratio only when not visible. This is fallback for browsers without isIntersecting support
        _inView = instance.visible ? intersectionRatio > options.threshold : intersectionRatio >= options.threshold;
      }

      if (isIntersecting !== undefined) {
        // If isIntersecting is defined, ensure that the element is actually intersecting.
        // Otherwise it reports a threshold of 0
        _inView = _inView && isIntersecting;
      }

      instance.visible = _inView;
      instance.callback(_inView, intersectionRatio);
    }
  });
}

function useInView(ref, options) {
  if (options === void 0) {
    options = {};
  }

  // $FlowFixMe - useState is not exposed in React Flow lib yet
  var _React$useState = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(false),
      isInView = _React$useState[0],
      setInView = _React$useState[1]; // $FlowFixMe - useEffect is not exposed in React Flow lib yet


  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    if (ref.current) {
      observe(ref.current, function (inView) {
        setInView(inView);

        if (inView && options.triggerOnce) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve(ref.current);
        }
      }, {
        threshold: options.threshold,
        root: options.root,
        rootMargin: options.rootMargin
      }, options.rootId);
    }

    return function () {
      unobserve(ref.current);
    };
  }, [options.threshold, options.root, options.rootMargin, options.rootId]);
  return isInView;
}

/**
 * Monitors scroll, and triggers the children function with updated props
 *
 <InView>
 {({inView, ref}) => (
   <h1 ref={ref}>{`${inView}`}</h1>
 )}
 </InView>
 */
var InView =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(InView, _React$Component);

  function InView() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {
      inView: false,
      intersectionRatio: 0
    });

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "node", null);

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleNode", function (node) {
      if (_this.node) unobserve(_this.node);
      _this.node = node;

      _this.observeNode();
    });

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleChange", function (inView, intersectionRatio) {
      _this.setState({
        inView: inView,
        intersectionRatio: intersectionRatio
      });

      if (_this.props.onChange) {
        _this.props.onChange(inView, intersectionRatio);
      }
    });

    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (false) {
      if (this.props.hasOwnProperty('render')) {
        console.warn("react-intersection-observer: \"render\" is deprecated, and should be replaced with \"children\"", this.node);
      }

      invariant(this.node, "react-intersection-observer: No DOM node found. Make sure you forward \"ref\" to the root DOM element you want to observe.");
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold) {
      unobserve(this.node);
      this.observeNode();
    }

    if (prevState.inView !== this.state.inView) {
      if (this.state.inView && this.props.triggerOnce) {
        unobserve(this.node);
        this.node = null;
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.node) {
      unobserve(this.node);
      this.node = null;
    }
  };

  _proto.observeNode = function observeNode() {
    if (!this.node) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        rootId = _this$props.rootId;
    observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin
    }, rootId);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        render = _this$props2.render,
        tag = _this$props2.tag,
        triggerOnce = _this$props2.triggerOnce,
        threshold = _this$props2.threshold,
        root = _this$props2.root,
        rootId = _this$props2.rootId,
        rootMargin = _this$props2.rootMargin,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["children", "render", "tag", "triggerOnce", "threshold", "root", "rootId", "rootMargin"]);

    var _this$state = this.state,
        inView = _this$state.inView,
        intersectionRatio = _this$state.intersectionRatio;
    var renderMethod = children || render;

    if (typeof renderMethod === 'function') {
      return renderMethod({
        inView: inView,
        intersectionRatio: intersectionRatio,
        ref: this.handleNode
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_5_react__["createElement"])(tag || 'div', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(InView, "defaultProps", {
  threshold: 0,
  triggerOnce: false
});

/* harmony default export */ __webpack_exports__["a"] = (InView);



/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function unionize(record, config) {
    var _a = config || {}, _b = _a.value, valProp = _b === void 0 ? undefined : _b, _c = _a.tag, tagProp = _c === void 0 ? 'tag' : _c;
    var creators = {};
    var _loop_1 = function (tag) {
        creators[tag] = (function (value) {
            var _a, _b;
            if (value === void 0) { value = {}; }
            return valProp ? (_a = {}, _a[tagProp] = tag, _a[valProp] = value, _a) : __assign({}, value, (_b = {}, _b[tagProp] = tag, _b));
        });
    };
    for (var tag in record) {
        _loop_1(tag);
    }
    var is = {};
    var _loop_2 = function (tag) {
        is[tag] = (function (variant) { return variant[tagProp] === tag; });
    };
    for (var tag in record) {
        _loop_2(tag);
    }
    function evalMatch(variant, cases, defaultCase) {
        if (defaultCase === void 0) { defaultCase = cases.default; }
        var handler = cases[variant[tagProp]];
        return handler ? handler(valProp ? variant[valProp] : variant) : defaultCase(variant);
    }
    var match = function (first, second) {
        return second ? evalMatch(first, second) : function (variant) { return evalMatch(variant, first); };
    };
    var identity = function (x) { return x; };
    var transform = function (first, second) {
        return second
            ? evalMatch(first, second, identity)
            : function (variant) { return evalMatch(variant, first, identity); };
    };
    var as = {};
    var _loop_3 = function (expectedTag) {
        var _a;
        as[expectedTag] = match((_a = {},
            _a[expectedTag] = function (x) { return x; },
            _a.default = function (val) {
                throw new Error("Attempted to cast " + val[tagProp] + " as " + expectedTag);
            },
            _a));
    };
    for (var expectedTag in record) {
        _loop_3(expectedTag);
    }
    return Object.assign({
        is: is,
        as: as,
        match: match,
        transform: transform,
        _Record: record,
    }, creators);
}
exports.unionize = unionize;
/**
 * Creates a pseudo-witness of a given type. That is, it pretends to return a value of
 * type `T` for any `T`, but it's really just returning `undefined`. This white lie
 * allows convenient expression of the value types in the record you pass to `unionize`.
 */
exports.ofType = function () { return undefined; };
exports.default = unionize;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postData = exports.truncate = exports.baseURL = undefined;

var _regenerator = __webpack_require__(39);

var _regenerator2 = _interopRequireDefault(_regenerator);

// Example POST method implementation:
var postData = exports.postData = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(page) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var newUrl, response;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Default options are marked with *
            newUrl = baseURL + page;
            _context.next = 3;
            return fetch(newUrl, {
              method: 'POST', // *GET, POST, PUT, DELETE, etc.
              mode: 'cors', // no-cors, *cors, same-origin
              cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
              credentials: 'same-origin', // include, *same-origin, omit
              headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
              },
              redirect: 'follow', // manual, *follow, error
              referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
              body: JSON.stringify(data) // body data type must match "Content-Type" header
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.json());

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function postData(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var baseURL = exports.baseURL =  true ? "https://investiv-server.herokuapp.com/" : "http://localhost:2000/";

var truncate = exports.truncate = function truncate(string) {
  return string.length > 200 ? string.substring(0, 200) + "..." : string;
};

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconStack = exports.Icon = exports.default = undefined;

__webpack_require__(547);

var _Icon = __webpack_require__(548);

var _Icon2 = _interopRequireDefault(_Icon);

var _IconStack = __webpack_require__(549);

var _IconStack2 = _interopRequireDefault(_IconStack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Icon2.default;
exports.Icon = _Icon2.default;
exports.IconStack = _IconStack2.default; /**
                                          * @copyright 2015, Andrey Popp <8mayday@gmail.com>
                                          * 
                                          */


/***/ }),

/***/ 547:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @copyright 2015, Andrey Popp <8mayday@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var Icon = function (_React$Component) {
  _inherits(Icon, _React$Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          Component = _props.Component,
          name = _props.name,
          size = _props.size,
          rotate = _props.rotate,
          flip = _props.flip,
          spin = _props.spin,
          fixedWidth = _props.fixedWidth,
          stack = _props.stack,
          inverse = _props.inverse,
          pulse = _props.pulse,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['Component', 'name', 'size', 'rotate', 'flip', 'spin', 'fixedWidth', 'stack', 'inverse', 'pulse', 'className']);

      var classNames = 'fa fa-' + name;
      if (size) {
        classNames = classNames + ' fa-' + size;
      }
      if (rotate) {
        classNames = classNames + ' fa-rotate-' + rotate;
      }
      if (flip) {
        classNames = classNames + ' fa-flip-' + flip;
      }
      if (fixedWidth) {
        classNames = classNames + ' fa-fw';
      }
      if (spin) {
        classNames = classNames + ' fa-spin';
      }
      if (pulse) {
        classNames = classNames + ' fa-pulse';
      }

      if (stack) {
        classNames = classNames + ' fa-stack-' + stack;
      }
      if (inverse) {
        classNames = classNames + ' fa-inverse';
      }

      if (className) {
        classNames = classNames + ' ' + className;
      }
      return React.createElement(Component, _extends({}, props, { className: classNames }));
    }
  }]);

  return Icon;
}(React.Component);

Icon.propTypes = {
  name: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
  rotate: _propTypes2.default.oneOf(['45', '90', '135', '180', '225', '270', '315']),
  flip: _propTypes2.default.oneOf(['horizontal', 'vertical']),
  fixedWidth: _propTypes2.default.bool,
  spin: _propTypes2.default.bool,
  pulse: _propTypes2.default.bool,
  stack: _propTypes2.default.oneOf(['1x', '2x']),
  inverse: _propTypes2.default.bool,
  Component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
};
Icon.defaultProps = {
  Component: 'span'
};
exports.default = Icon;


/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @copyright 2015, Andrey Popp <8mayday@gmail.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var IconStack = function (_React$Component) {
  _inherits(IconStack, _React$Component);

  function IconStack() {
    _classCallCheck(this, IconStack);

    return _possibleConstructorReturn(this, (IconStack.__proto__ || Object.getPrototypeOf(IconStack)).apply(this, arguments));
  }

  _createClass(IconStack, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          size = _props.size,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['className', 'size', 'children']);

      var classNames = ['fa-stack'];

      if (size) {
        classNames.push('fa-' + size);
      }

      if (className) {
        classNames.push(className);
      }

      var iconStackClassName = classNames.join(' ');

      return React.createElement(
        'span',
        _extends({}, props, { className: iconStackClassName }),
        children
      );
    }
  }]);

  return IconStack;
}(React.Component);

IconStack.propTypes = {
  className: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
  children: _propTypes2.default.node.isRequired
};
exports.default = IconStack;


/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.json = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(185);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactLocalizeRedux = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var json = exports.json = [{
  "name": "Afghanistan",
  "dial_code": "+93",
  "code": "AF"
}, {
  "name": "Aland Islands",
  "dial_code": "+358",
  "code": "AX"
}, {
  "name": "Albania",
  "dial_code": "+355",
  "code": "AL"
}, {
  "name": "Algeria",
  "dial_code": "+213",
  "code": "DZ"
}, {
  "name": "AmericanSamoa",
  "dial_code": "+1684",
  "code": "AS"
}, {
  "name": "Andorra",
  "dial_code": "+376",
  "code": "AD"
}, {
  "name": "Angola",
  "dial_code": "+244",
  "code": "AO"
}, {
  "name": "Anguilla",
  "dial_code": "+1264",
  "code": "AI"
}, {
  "name": "Antarctica",
  "dial_code": "+672",
  "code": "AQ"
}, {
  "name": "Antigua and Barbuda",
  "dial_code": "+1268",
  "code": "AG"
}, {
  "name": "Argentina",
  "dial_code": "+54",
  "code": "AR"
}, {
  "name": "Armenia",
  "dial_code": "+374",
  "code": "AM"
}, {
  "name": "Aruba",
  "dial_code": "+297",
  "code": "AW"
}, {
  "name": "Australia",
  "dial_code": "+61",
  "code": "AU"
}, {
  "name": "Austria",
  "dial_code": "+43",
  "code": "AT"
}, {
  "name": "Azerbaijan",
  "dial_code": "+994",
  "code": "AZ"
}, {
  "name": "Bahamas",
  "dial_code": "+1242",
  "code": "BS"
}, {
  "name": "Bahrain",
  "dial_code": "+973",
  "code": "BH"
}, {
  "name": "Bangladesh",
  "dial_code": "+880",
  "code": "BD"
}, {
  "name": "Barbados",
  "dial_code": "+1246",
  "code": "BB"
}, {
  "name": "Belarus",
  "dial_code": "+375",
  "code": "BY"
}, {
  "name": "Belgium",
  "dial_code": "+32",
  "code": "BE"
}, {
  "name": "Belize",
  "dial_code": "+501",
  "code": "BZ"
}, {
  "name": "Benin",
  "dial_code": "+229",
  "code": "BJ"
}, {
  "name": "Bermuda",
  "dial_code": "+1441",
  "code": "BM"
}, {
  "name": "Bhutan",
  "dial_code": "+975",
  "code": "BT"
}, {
  "name": "Bolivia, Plurinational State of",
  "dial_code": "+591",
  "code": "BO"
}, {
  "name": "Bosnia and Herzegovina",
  "dial_code": "+387",
  "code": "BA"
}, {
  "name": "Botswana",
  "dial_code": "+267",
  "code": "BW"
}, {
  "name": "Brazil",
  "dial_code": "+55",
  "code": "BR"
}, {
  "name": "British Indian Ocean Territory",
  "dial_code": "+246",
  "code": "IO"
}, {
  "name": "Brunei Darussalam",
  "dial_code": "+673",
  "code": "BN"
}, {
  "name": "Bulgaria",
  "dial_code": "+359",
  "code": "BG"
}, {
  "name": "Burkina Faso",
  "dial_code": "+226",
  "code": "BF"
}, {
  "name": "Burundi",
  "dial_code": "+257",
  "code": "BI"
}, {
  "name": "Cambodia",
  "dial_code": "+855",
  "code": "KH"
}, {
  "name": "Cameroon",
  "dial_code": "+237",
  "code": "CM"
}, {
  "name": "Canada",
  "dial_code": "+1",
  "code": "CA"
}, {
  "name": "Cape Verde",
  "dial_code": "+238",
  "code": "CV"
}, {
  "name": "Cayman Islands",
  "dial_code": "+ 345",
  "code": "KY"
}, {
  "name": "Central African Republic",
  "dial_code": "+236",
  "code": "CF"
}, {
  "name": "Chad",
  "dial_code": "+235",
  "code": "TD"
}, {
  "name": "Chile",
  "dial_code": "+56",
  "code": "CL"
}, {
  "name": "China",
  "dial_code": "+86",
  "code": "CN"
}, {
  "name": "Christmas Island",
  "dial_code": "+61",
  "code": "CX"
}, {
  "name": "Cocos (Keeling) Islands",
  "dial_code": "+61",
  "code": "CC"
}, {
  "name": "Colombia",
  "dial_code": "+57",
  "code": "CO"
}, {
  "name": "Comoros",
  "dial_code": "+269",
  "code": "KM"
}, {
  "name": "Congo",
  "dial_code": "+242",
  "code": "CG"
}, {
  "name": "Congo, The Democratic Republic of the Congo",
  "dial_code": "+243",
  "code": "CD"
}, {
  "name": "Cook Islands",
  "dial_code": "+682",
  "code": "CK"
}, {
  "name": "Costa Rica",
  "dial_code": "+506",
  "code": "CR"
}, {
  "name": "Cote d'Ivoire",
  "dial_code": "+225",
  "code": "CI"
}, {
  "name": "Croatia",
  "dial_code": "+385",
  "code": "HR"
}, {
  "name": "Cuba",
  "dial_code": "+53",
  "code": "CU"
}, {
  "name": "Cyprus",
  "dial_code": "+357",
  "code": "CY"
}, {
  "name": "Czech Republic",
  "dial_code": "+420",
  "code": "CZ"
}, {
  "name": "Denmark",
  "dial_code": "+45",
  "code": "DK"
}, {
  "name": "Djibouti",
  "dial_code": "+253",
  "code": "DJ"
}, {
  "name": "Dominica",
  "dial_code": "+1767",
  "code": "DM"
}, {
  "name": "Dominican Republic",
  "dial_code": "+1849",
  "code": "DO"
}, {
  "name": "Ecuador",
  "dial_code": "+593",
  "code": "EC"
}, {
  "name": "Egypt",
  "dial_code": "+20",
  "code": "EG"
}, {
  "name": "El Salvador",
  "dial_code": "+503",
  "code": "SV"
}, {
  "name": "Equatorial Guinea",
  "dial_code": "+240",
  "code": "GQ"
}, {
  "name": "Eritrea",
  "dial_code": "+291",
  "code": "ER"
}, {
  "name": "Estonia",
  "dial_code": "+372",
  "code": "EE"
}, {
  "name": "Ethiopia",
  "dial_code": "+251",
  "code": "ET"
}, {
  "name": "Falkland Islands (Malvinas)",
  "dial_code": "+500",
  "code": "FK"
}, {
  "name": "Faroe Islands",
  "dial_code": "+298",
  "code": "FO"
}, {
  "name": "Fiji",
  "dial_code": "+679",
  "code": "FJ"
}, {
  "name": "Finland",
  "dial_code": "+358",
  "code": "FI"
}, {
  "name": "France",
  "dial_code": "+33",
  "code": "FR"
}, {
  "name": "French Guiana",
  "dial_code": "+594",
  "code": "GF"
}, {
  "name": "French Polynesia",
  "dial_code": "+689",
  "code": "PF"
}, {
  "name": "Gabon",
  "dial_code": "+241",
  "code": "GA"
}, {
  "name": "Gambia",
  "dial_code": "+220",
  "code": "GM"
}, {
  "name": "Georgia",
  "dial_code": "+995",
  "code": "GE"
}, {
  "name": "Germany",
  "dial_code": "+49",
  "code": "DE"
}, {
  "name": "Ghana",
  "dial_code": "+233",
  "code": "GH"
}, {
  "name": "Gibraltar",
  "dial_code": "+350",
  "code": "GI"
}, {
  "name": "Greece",
  "dial_code": "+30",
  "code": "GR"
}, {
  "name": "Greenland",
  "dial_code": "+299",
  "code": "GL"
}, {
  "name": "Grenada",
  "dial_code": "+1473",
  "code": "GD"
}, {
  "name": "Guadeloupe",
  "dial_code": "+590",
  "code": "GP"
}, {
  "name": "Guam",
  "dial_code": "+1671",
  "code": "GU"
}, {
  "name": "Guatemala",
  "dial_code": "+502",
  "code": "GT"
}, {
  "name": "Guernsey",
  "dial_code": "+44",
  "code": "GG"
}, {
  "name": "Guinea",
  "dial_code": "+224",
  "code": "GN"
}, {
  "name": "Guinea-Bissau",
  "dial_code": "+245",
  "code": "GW"
}, {
  "name": "Guyana",
  "dial_code": "+595",
  "code": "GY"
}, {
  "name": "Haiti",
  "dial_code": "+509",
  "code": "HT"
}, {
  "name": "Holy See (Vatican City State)",
  "dial_code": "+379",
  "code": "VA"
}, {
  "name": "Honduras",
  "dial_code": "+504",
  "code": "HN"
}, {
  "name": "Hong Kong",
  "dial_code": "+852",
  "code": "HK"
}, {
  "name": "Hungary",
  "dial_code": "+36",
  "code": "HU"
}, {
  "name": "Iceland",
  "dial_code": "+354",
  "code": "IS"
}, {
  "name": "India",
  "dial_code": "+91",
  "code": "IN"
}, {
  "name": "Indonesia",
  "dial_code": "+62",
  "code": "ID"
}, {
  "name": "Iran, Islamic Republic of Persian Gulf",
  "dial_code": "+98",
  "code": "IR"
}, {
  "name": "Iraq",
  "dial_code": "+964",
  "code": "IQ"
}, {
  "name": "Ireland",
  "dial_code": "+353",
  "code": "IE"
}, {
  "name": "Isle of Man",
  "dial_code": "+44",
  "code": "IM"
}, {
  "name": "Israel",
  "dial_code": "+972",
  "code": "IL"
}, {
  "name": "Italy",
  "dial_code": "+39",
  "code": "IT"
}, {
  "name": "Jamaica",
  "dial_code": "+1876",
  "code": "JM"
}, {
  "name": "Japan",
  "dial_code": "+81",
  "code": "JP"
}, {
  "name": "Jersey",
  "dial_code": "+44",
  "code": "JE"
}, {
  "name": "Jordan",
  "dial_code": "+962",
  "code": "JO"
}, {
  "name": "Kazakhstan",
  "dial_code": "+77",
  "code": "KZ"
}, {
  "name": "Kenya",
  "dial_code": "+254",
  "code": "KE"
}, {
  "name": "Kiribati",
  "dial_code": "+686",
  "code": "KI"
}, {
  "name": "Korea, Democratic People's Republic of Korea",
  "dial_code": "+850",
  "code": "KP"
}, {
  "name": "Korea, Republic of South Korea",
  "dial_code": "+82",
  "code": "KR"
}, {
  "name": "Kuwait",
  "dial_code": "+965",
  "code": "KW"
}, {
  "name": "Kyrgyzstan",
  "dial_code": "+996",
  "code": "KG"
}, {
  "name": "Laos",
  "dial_code": "+856",
  "code": "LA"
}, {
  "name": "Latvia",
  "dial_code": "+371",
  "code": "LV"
}, {
  "name": "Lebanon",
  "dial_code": "+961",
  "code": "LB"
}, {
  "name": "Lesotho",
  "dial_code": "+266",
  "code": "LS"
}, {
  "name": "Liberia",
  "dial_code": "+231",
  "code": "LR"
}, {
  "name": "Libyan Arab Jamahiriya",
  "dial_code": "+218",
  "code": "LY"
}, {
  "name": "Liechtenstein",
  "dial_code": "+423",
  "code": "LI"
}, {
  "name": "Lithuania",
  "dial_code": "+370",
  "code": "LT"
}, {
  "name": "Luxembourg",
  "dial_code": "+352",
  "code": "LU"
}, {
  "name": "Macao",
  "dial_code": "+853",
  "code": "MO"
}, {
  "name": "Macedonia",
  "dial_code": "+389",
  "code": "MK"
}, {
  "name": "Madagascar",
  "dial_code": "+261",
  "code": "MG"
}, {
  "name": "Malawi",
  "dial_code": "+265",
  "code": "MW"
}, {
  "name": "Malaysia",
  "dial_code": "+60",
  "code": "MY"
}, {
  "name": "Maldives",
  "dial_code": "+960",
  "code": "MV"
}, {
  "name": "Mali",
  "dial_code": "+223",
  "code": "ML"
}, {
  "name": "Malta",
  "dial_code": "+356",
  "code": "MT"
}, {
  "name": "Marshall Islands",
  "dial_code": "+692",
  "code": "MH"
}, {
  "name": "Martinique",
  "dial_code": "+596",
  "code": "MQ"
}, {
  "name": "Mauritania",
  "dial_code": "+222",
  "code": "MR"
}, {
  "name": "Mauritius",
  "dial_code": "+230",
  "code": "MU"
}, {
  "name": "Mayotte",
  "dial_code": "+262",
  "code": "YT"
}, {
  "name": "Mexico",
  "dial_code": "+52",
  "code": "MX"
}, {
  "name": "Micronesia, Federated States of Micronesia",
  "dial_code": "+691",
  "code": "FM"
}, {
  "name": "Moldova",
  "dial_code": "+373",
  "code": "MD"
}, {
  "name": "Monaco",
  "dial_code": "+377",
  "code": "MC"
}, {
  "name": "Mongolia",
  "dial_code": "+976",
  "code": "MN"
}, {
  "name": "Montenegro",
  "dial_code": "+382",
  "code": "ME"
}, {
  "name": "Montserrat",
  "dial_code": "+1664",
  "code": "MS"
}, {
  "name": "Morocco",
  "dial_code": "+212",
  "code": "MA"
}, {
  "name": "Mozambique",
  "dial_code": "+258",
  "code": "MZ"
}, {
  "name": "Myanmar",
  "dial_code": "+95",
  "code": "MM"
}, {
  "name": "Namibia",
  "dial_code": "+264",
  "code": "NA"
}, {
  "name": "Nauru",
  "dial_code": "+674",
  "code": "NR"
}, {
  "name": "Nepal",
  "dial_code": "+977",
  "code": "NP"
}, {
  "name": "Netherlands",
  "dial_code": "+31",
  "code": "NL"
}, {
  "name": "Netherlands Antilles",
  "dial_code": "+599",
  "code": "AN"
}, {
  "name": "New Caledonia",
  "dial_code": "+687",
  "code": "NC"
}, {
  "name": "New Zealand",
  "dial_code": "+64",
  "code": "NZ"
}, {
  "name": "Nicaragua",
  "dial_code": "+505",
  "code": "NI"
}, {
  "name": "Niger",
  "dial_code": "+227",
  "code": "NE"
}, {
  "name": "Nigeria",
  "dial_code": "+234",
  "code": "NG"
}, {
  "name": "Niue",
  "dial_code": "+683",
  "code": "NU"
}, {
  "name": "Norfolk Island",
  "dial_code": "+672",
  "code": "NF"
}, {
  "name": "Northern Mariana Islands",
  "dial_code": "+1670",
  "code": "MP"
}, {
  "name": "Norway",
  "dial_code": "+47",
  "code": "NO"
}, {
  "name": "Oman",
  "dial_code": "+968",
  "code": "OM"
}, {
  "name": "Pakistan",
  "dial_code": "+92",
  "code": "PK"
}, {
  "name": "Palau",
  "dial_code": "+680",
  "code": "PW"
}, {
  "name": "Palestinian Territory, Occupied",
  "dial_code": "+970",
  "code": "PS"
}, {
  "name": "Panama",
  "dial_code": "+507",
  "code": "PA"
}, {
  "name": "Papua New Guinea",
  "dial_code": "+675",
  "code": "PG"
}, {
  "name": "Paraguay",
  "dial_code": "+595",
  "code": "PY"
}, {
  "name": "Peru",
  "dial_code": "+51",
  "code": "PE"
}, {
  "name": "Philippines",
  "dial_code": "+63",
  "code": "PH"
}, {
  "name": "Pitcairn",
  "dial_code": "+872",
  "code": "PN"
}, {
  "name": "Poland",
  "dial_code": "+48",
  "code": "PL"
}, {
  "name": "Portugal",
  "dial_code": "+351",
  "code": "PT"
}, {
  "name": "Puerto Rico",
  "dial_code": "+1939",
  "code": "PR"
}, {
  "name": "Qatar",
  "dial_code": "+974",
  "code": "QA"
}, {
  "name": "Romania",
  "dial_code": "+40",
  "code": "RO"
}, {
  "name": "Russia",
  "dial_code": "+7",
  "code": "RU"
}, {
  "name": "Rwanda",
  "dial_code": "+250",
  "code": "RW"
}, {
  "name": "Reunion",
  "dial_code": "+262",
  "code": "RE"
}, {
  "name": "Saint Barthelemy",
  "dial_code": "+590",
  "code": "BL"
}, {
  "name": "Saint Helena, Ascension and Tristan Da Cunha",
  "dial_code": "+290",
  "code": "SH"
}, {
  "name": "Saint Kitts and Nevis",
  "dial_code": "+1869",
  "code": "KN"
}, {
  "name": "Saint Lucia",
  "dial_code": "+1758",
  "code": "LC"
}, {
  "name": "Saint Martin",
  "dial_code": "+590",
  "code": "MF"
}, {
  "name": "Saint Pierre and Miquelon",
  "dial_code": "+508",
  "code": "PM"
}, {
  "name": "Saint Vincent and the Grenadines",
  "dial_code": "+1784",
  "code": "VC"
}, {
  "name": "Samoa",
  "dial_code": "+685",
  "code": "WS"
}, {
  "name": "San Marino",
  "dial_code": "+378",
  "code": "SM"
}, {
  "name": "Sao Tome and Principe",
  "dial_code": "+239",
  "code": "ST"
}, {
  "name": "Saudi Arabia",
  "dial_code": "+966",
  "code": "SA"
}, {
  "name": "Senegal",
  "dial_code": "+221",
  "code": "SN"
}, {
  "name": "Serbia",
  "dial_code": "+381",
  "code": "RS"
}, {
  "name": "Seychelles",
  "dial_code": "+248",
  "code": "SC"
}, {
  "name": "Sierra Leone",
  "dial_code": "+232",
  "code": "SL"
}, {
  "name": "Singapore",
  "dial_code": "+65",
  "code": "SG"
}, {
  "name": "Slovakia",
  "dial_code": "+421",
  "code": "SK"
}, {
  "name": "Slovenia",
  "dial_code": "+386",
  "code": "SI"
}, {
  "name": "Solomon Islands",
  "dial_code": "+677",
  "code": "SB"
}, {
  "name": "Somalia",
  "dial_code": "+252",
  "code": "SO"
}, {
  "name": "South Africa",
  "dial_code": "+27",
  "code": "ZA"
}, {
  "name": "South Sudan",
  "dial_code": "+211",
  "code": "SS"
}, {
  "name": "South Georgia and the South Sandwich Islands",
  "dial_code": "+500",
  "code": "GS"
}, {
  "name": "Spain",
  "dial_code": "+34",
  "code": "ES"
}, {
  "name": "Sri Lanka",
  "dial_code": "+94",
  "code": "LK"
}, {
  "name": "Sudan",
  "dial_code": "+249",
  "code": "SD"
}, {
  "name": "Suriname",
  "dial_code": "+597",
  "code": "SR"
}, {
  "name": "Svalbard and Jan Mayen",
  "dial_code": "+47",
  "code": "SJ"
}, {
  "name": "Swaziland",
  "dial_code": "+268",
  "code": "SZ"
}, {
  "name": "Sweden",
  "dial_code": "+46",
  "code": "SE"
}, {
  "name": "Switzerland",
  "dial_code": "+41",
  "code": "CH"
}, {
  "name": "Syrian Arab Republic",
  "dial_code": "+963",
  "code": "SY"
}, {
  "name": "Taiwan",
  "dial_code": "+886",
  "code": "TW"
}, {
  "name": "Tajikistan",
  "dial_code": "+992",
  "code": "TJ"
}, {
  "name": "Tanzania, United Republic of Tanzania",
  "dial_code": "+255",
  "code": "TZ"
}, {
  "name": "Thailand",
  "dial_code": "+66",
  "code": "TH"
}, {
  "name": "Timor-Leste",
  "dial_code": "+670",
  "code": "TL"
}, {
  "name": "Togo",
  "dial_code": "+228",
  "code": "TG"
}, {
  "name": "Tokelau",
  "dial_code": "+690",
  "code": "TK"
}, {
  "name": "Tonga",
  "dial_code": "+676",
  "code": "TO"
}, {
  "name": "Trinidad and Tobago",
  "dial_code": "+1868",
  "code": "TT"
}, {
  "name": "Tunisia",
  "dial_code": "+216",
  "code": "TN"
}, {
  "name": "Turkey",
  "dial_code": "+90",
  "code": "TR"
}, {
  "name": "Turkmenistan",
  "dial_code": "+993",
  "code": "TM"
}, {
  "name": "Turks and Caicos Islands",
  "dial_code": "+1649",
  "code": "TC"
}, {
  "name": "Tuvalu",
  "dial_code": "+688",
  "code": "TV"
}, {
  "name": "Uganda",
  "dial_code": "+256",
  "code": "UG"
}, {
  "name": "Ukraine",
  "dial_code": "+380",
  "code": "UA"
}, {
  "name": "United Arab Emirates",
  "dial_code": "+971",
  "code": "AE"
}, {
  "name": "United Kingdom",
  "dial_code": "+44",
  "code": "GB"
}, {
  "name": "United States",
  "dial_code": "+1",
  "code": "US"
}, {
  "name": "Uruguay",
  "dial_code": "+598",
  "code": "UY"
}, {
  "name": "Uzbekistan",
  "dial_code": "+998",
  "code": "UZ"
}, {
  "name": "Vanuatu",
  "dial_code": "+678",
  "code": "VU"
}, {
  "name": "Venezuela, Bolivarian Republic of Venezuela",
  "dial_code": "+58",
  "code": "VE"
}, {
  "name": "Vietnam",
  "dial_code": "+84",
  "code": "VN"
}, {
  "name": "Virgin Islands, British",
  "dial_code": "+1284",
  "code": "VG"
}, {
  "name": "Virgin Islands, U.S.",
  "dial_code": "+1340",
  "code": "VI"
}, {
  "name": "Wallis and Futuna",
  "dial_code": "+681",
  "code": "WF"
}, {
  "name": "Yemen",
  "dial_code": "+967",
  "code": "YE"
}, {
  "name": "Zambia",
  "dial_code": "+260",
  "code": "ZM"
}, {
  "name": "Zimbabwe",
  "dial_code": "+263",
  "code": "ZW"
}];

var CountrySelector = function (_React$PureComponent) {
  _inherits(CountrySelector, _React$PureComponent);

  function CountrySelector(props) {
    _classCallCheck(this, CountrySelector);

    var _this = _possibleConstructorReturn(this, (CountrySelector.__proto__ || Object.getPrototypeOf(CountrySelector)).call(this, props));

    _this.changeHandler = function (value) {
      return _this.setState({ value: value });
    };

    _this.state = { value: json[0].dial_code };
    return _this;
  }

  _createClass(CountrySelector, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'select',
        { 'data-name': 'countryCode', onChange: this.props.onChange },
        json.map(function (country, n) {
          return _react2.default.createElement(
            'option',
            { key: n, value: country.dial_code },
            country.name,
            ' (',
            country.dial_code,
            ') '
          );
        })
      );
    }
  }]);

  return CountrySelector;
}(_react2.default.PureComponent);

exports.default = CountrySelector;

/***/ }),

/***/ 784:
/***/ (function(module, exports) {

module.exports = [{"role":"Full Stack Software Engineer","translated":"Informaticien - Développeur d'application (H/F)","url":"/offre-d-emploi"}]

/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__(87);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _contactbackground = __webpack_require__(942);

var _contactbackground2 = _interopRequireDefault(_contactbackground);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _styledComponents2.default.div.withConfig({
  displayName: "contactstyle__Wrapper",
  componentId: "sc-hjyew0-0"
})([".header{position:relative;background:url(", ");background-repeat:no-repeat;background-size:cover;background-position:top;@media(min-width:2000px){background-position:0 -20em;}background-size:cover;background-position:top;position:relative;z-index:0;height:400px;display:flex;flex-direction:column;align-content:flex-start;align-items:flex-start;justify-content:center;padding:0 1.75em;&::before{content:\"\";position:absolute;top:0;bottom:0;left:0;right:0;height:100%;width:100%;background:rgba(0,0,0,0);z-index:-1;}display:flex;flex-direction:column;justify-content:center;h3{margin:0;font-weight:1000;font-size:26px;text-transform:uppercase;text-align:left;font-style:italic;}p{font-weight:600;font-size:3em;@media(max-width:1024px){font-size:2em;}}h3,p{color:white;;}}.content{padding:3em 15px;.flex-wrap{display:flex;align-items:center;justify-content:flex-start;flex-direction:row;padding-bottom:3em;}h1{margin:20px 0 15px;font-size:42px;padding:0;font-weight:500;color:#009444;text-align:left;font-family:Poppins;width:200px;}.text-content{font-weight:500;color:black;font-family:Poppins;text-align:left;font-size:21px;line-height:36px;margin-top:0;margin-bottom:10px;letter-spacing:1px;}a.option{text-decoration:none;width:100%;padding:1em 0;color:black;display:flex;align-items:center;justify-content:space-between;border-bottom:2px solid #009444;font-size:23px;}}.form-content{form{.form-control{padding:1em 0;}@media(min-width:768px){.form-control{padding-right:1em;}}label,input,select{line-height:22px;font-size:18px;}input,select,textarea{padding:0.65em 0;width:100%;border:0;border-bottom:2px solid #009444;outline:none;border-radius:0;}button{background-color:#009444;color:#fff;font-family:Poppins;border-radius:20px;text-transform:uppercase;padding:10px 30px;font-weight:500;border:2px solid #009444;font-size:18px;}textarea{height:250px;width:100%;padding:1em 1em 1em 0.15em;font-size:18px;line-height:22px;font-family:Arial;letter-spacing:0.5px;}}}}@media(max-width:768px){.header{padding:0;height:250px;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;}p,li,span{font-size:14.5px !important;line-height:30px !important;}.header h3{font-size:21px;}.header h3,.header p{margin-left:1em !important;}.header p{font-size:1.25em !important;line-height:1.7em !important;letter-spacing:0.75px;font-weight:600;}}.cjsx{display:flex;align-items:flex-end;justify-content:center;flex-direction:row;@media(max-width:1024px){flex-direction:column;}}#submit{flex-direction:row !important;align-items:center;justify-content:center;margin:auto;width:150px;padding-left:0 !important;padding-right:0 !important;span{margin-left:1em;}}"], _contactbackground2.default);

exports.default = Wrapper;

/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/contactbackground.5f5cccd4.jpeg";

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Contact.31e6c1be.js